module.exports = __webpack_public_path__ + "static/media/selfie.bc4a930e.svg";